module.exports = __webpack_public_path__ + "img/smoke.3f0789c0.png";